import React, { useState, useEffect } from 'react';
import '../App.css';
import { Link, useLocation } from 'react-router-dom';
import { Form, FormGroup, Button, Label, Input } from 'reactstrap';
import MyLoader from './util/loader'
import Api from './api/api'
import showToast from './util/toast'
import { ToastContainer, toast } from 'react-toastify';

const SendNotification = () => {
    const location = useLocation()

    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [loader, setLoader] = useState(false);

    const sendNotification = () => {
        if (title === '') {
            showToast('error', 'Please enter title!')
            return
        }
        if (body === '') {
            showToast('error', 'Please enter body!')
            return
        }

        setLoader(true)
        Api.sendPushToAll(title, body, 
            ()=>{
                setLoader(false)
                showToast('success', 'Notification Sent!')
            },
            ()=>{
                setLoader(false)
                showToast('error', 'Notification Failed!')
            })
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Send Push Notification
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 15 }}>
                <Form className="form" style={{ width: 600, marginTop: 20, backgroundColor: '#f2f2f2' }}>
                    <FormGroup style={{ marginTop: 0 }}>
                        <Input
                            type='text'
                            placeholder='Notification Title'
                            value={title}
                            onChange={(event) => {
                                setTitle(event.target.value)
                            }} />
                    </FormGroup>
                    <FormGroup style={{ marginTop: 10 }}>
                        <Input
                            type='textarea'
                            placeholder='Notification Body'
                            value={body}
                            onChange={(event) => {
                                setBody(event.target.value)
                            }} />
                    </FormGroup>
                    <Button
                        style={{ marginTop: 20 , fontSize: 16}}
                        className='btn-block btn-dark'
                        onClick={() => {
                            sendNotification()
                        }}>
                        Send Notification
                    </Button>
                </Form>
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default SendNotification;